<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg w-full max-w-md overflow-hidden">
      <!-- Header -->
      <header class="p-6 border-b">
        <h2 class="text-xl font-semibold">Confirm Launch</h2>
      </header>

      <!-- Content -->
      <main class="p-6 text-gray-700">
        <p>
          You are about to launch <strong>{{ tool.name }}</strong>.
          <span v-if="tool.cost">
            This will deduct <strong>{{ tool.cost }} credits</strong> from your account.
          </span>
        </p>
      </main>

      <!-- Footer with guaranteed space via padding and border -->
      <footer class="p-6 border-t flex justify-end space-x-4">
        <BaseButton variant="secondary" @click="$emit('cancel')">
          Cancel
        </BaseButton>
        <BaseButton variant="primary" @click="onConfirm">
          Confirm
        </BaseButton>
      </footer>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/ui/BaseButton.vue';

export default {
  name: 'LaunchModal',
  props: {
    tool: { type: Object, required: true }
  },
  components: { BaseButton },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.tool);
    }
  }
};
</script>

<style scoped>
/* No additional overrides needed; using border and padding ensures spacing */
</style>
